// Story cards must look identical on every screen. Their Tailwind sm:/md:/lg:/xl: classes
// follow the VIEWPORT, so phones got a different design. This copies every min-width
// media rule into an always-on copy scoped to `.story-desk`, so cards always use desktop styles.
let done = false;
export function ensureStoryDesk() {
    if (done || typeof document === "undefined") return;
    const out = [];
    for (const sheet of Array.from(document.styleSheets)) {
        let rules;
        try { rules = sheet.cssRules; } catch { continue; }
        for (const r of Array.from(rules || [])) {
            if (!(r instanceof CSSMediaRule) || !/min-width/.test(r.conditionText || r.media?.mediaText || "") || /max-width|prefers|print|hover|pointer/.test(r.conditionText || "")) continue;
            for (const inner of Array.from(r.cssRules)) {
                if (!(inner instanceof CSSStyleRule)) continue;
                const sel = inner.selectorText.split(",").map((s) => `.story-desk ${s.trim()}`).join(", ");
                out.push(`${sel}{${inner.style.cssText}}`);
            }
        }
    }
    if (!out.length) return;
    done = true;
    const el = document.createElement("style");
    el.setAttribute("data-story-desk", "1");
    el.textContent = out.join("\n");
    document.head.appendChild(el);
}
